export default __webpack_public_path__ + "static/media/art.9df7d04e.png";